<template>
    <a class="call-us-link" @click="callUs" :href='tellNo'>{{ $t('message.callUs') }}</a>
</template>

<script>
import axios from "axios";
import {identify, MX_TRACK} from "../utils/Mixpanel";
import Config from "../config/config";

export default {
  name: 'Footer',
  data() {
    return {
      tellNo: process.env.VUE_APP_CALL_US_NUMBER
    }
  },
  methods: {
    callUs() {
      this.mxTrackLanguageChange();
    },
    async mxTrackLanguageChange() {
      const demandId = this.$route.params.id;
      const mx_prop = {
        time: new Date().getTime(),
        page_src: this.$route.name,
      }
      if (demandId) {
        const {data} = await axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_URL}/demand/details/${demandId}`)
        if (data && data.success && data.value) {
          const {supplier_name, contact, supplier_id, user_type} = data.value
          identify(supplier_id)
          mx_prop.user_type = user_type;
          mx_prop.user_name = supplier_name;
          mx_prop.phone_number = contact;
          mx_prop.user_id = supplier_id;
        }
      }
      MX_TRACK(Config.MIXPANEL_EVENTS.CONTACT_US, mx_prop)
    }
  }
}
</script>

<style lang="scss">

  .call-us-link {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: #0D6EFD;
    text-decoration: none;
    text-transform: uppercase;
  }

</style>